import { UseInfiniteQueryResult } from '@tanstack/react-query';

// Keep stable reference
const EMPTY_INFINITE_DATA: unknown[] = [];
export function flattenInfiniteData<T, U = T>(
  result: UseInfiniteQueryResult<{ data: T[] }>,
  selector?: (item: T) => U
): U[] {
  return (
    result.data?.pages.flatMap((page) => {
      if (selector) {
        return page.data.map(selector);
      }
      return page.data as unknown as U[];
    }) ?? (EMPTY_INFINITE_DATA as U[])
  );
}

export function countInfiniteData<T>(
  result: UseInfiniteQueryResult<{ data: T[] }>
): number {
  return (
    result.data?.pages.reduce((acc, page) => {
      return acc + page.data.length;
    }, 0) ?? 0
  );
}
